import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './TransferenceApproveRepresentationModal.style.css';

function TransferenceApproveRepresentationModal({
  isOpen,
  patente,
  loading,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => (loading ? null : onCancel())}
      className="modal-approve-representation"
      contentClassName="arm-content"
      labelledBy="approve-representation-title"
      centered
      backdrop="static"
    >
      <div className="modal-header arm-header">
        <div className="arm-header-title">
          <span className="arm-icon-box">
            <FontAwesomeIcon icon="exclamation-triangle" className="arm-icon" />
          </span>
          <h2 className="modal-title arm-title" id="approve-representation-title">
            Aprobación de contrato con Poder de Representación
          </h2>
        </div>
        <button type="button" className="arm-close" aria-label="Cerrar" onClick={onCancel} disabled={loading}>
          <FontAwesomeIcon icon="times" />
        </button>
      </div>
      <div className="modal-body arm-body">
        <p className="arm-text">
          La transferencia para la patente
          {' '}
          <strong>{patente}</strong>
          {' '}
          incluye un
          {' '}
          <strong>Poder de Representación</strong>
          . Antes de continuar,
          {' '}
          <strong>verifica</strong>
          {' '}
          lo siguiente:
        </p>
        <ul className="arm-checklist">
          <li>
            <strong>Poder de representación:</strong>
            {' '}
            Válido y sin señales de adulteración.
          </li>
          <li>
            <strong>Vigencia:</strong>
            {' '}
            Debe estar vigente a la fecha actual.
          </li>
          <li>
            <strong>Titularidad:</strong>
            {' '}
            Corresponde al propietario actual del vehículo.
          </li>
          <li>
            <strong>Cédula de Identidad:</strong>
            {' '}
            Válida y sin señales de adulteración.
          </li>
        </ul>
        <p className="arm-question">
          <strong>¿Confirmas que los antecedentes son correctos y deseas continuar con la aprobación?</strong>
        </p>
      </div>
      <div className="modal-footer arm-footer">
        <button type="button" className="btn arm-btn arm-btn-outline" onClick={onCancel} disabled={loading}>
          Volver a revisar
        </button>
        <button type="button" className="btn arm-btn arm-btn-filled" onClick={onConfirm} disabled={loading}>
          {loading ? [
            <span key="arm-spinner" className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />,
            <span key="arm-label" className="ml-2">Aprobando...</span>,
          ] : <span>Confirmar y Aprobar</span>}
        </button>
      </div>
    </Modal>
  );
}

TransferenceApproveRepresentationModal.propTypes = {
  isOpen: PropTypes.bool,
  patente: PropTypes.string,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

export default TransferenceApproveRepresentationModal;
